import request from "@/utils/request";

export function me(params, config = {}) {
  return request({
    url: "/api/profile/me/",
    method: "get",
    params,
    ...config,
  });
}
